<template>
  <a
    :href="collectionComputed?.link"
    v-if="collectionComputed"
    :class="[
      'atom atom-collection-button self-center inline-block px-3 py-1 mb-4 text-black bg-white rounded-full',
      disableShadow ? 'drop-shadow-none' : 'drop-shadow',
      collectionComputed?.link ? 'cursor-pointer' : 'cursor-default',
    ]"
    :title="
      collectionComputed?.link
        ? 'Explore ' + collectionComputed?.collectionTitle
        : ''
    "
  >
    <img
      v-if="collectionComputed?.sourceUrl"
      class="inline-block w-5"
      :src="collectionComputed?.sourceUrl"
      :alt="collectionComputed?.alt"
    />
    <span
      :class="[
        'text-sm font-archer font-semibold',
        coloredText ? collectionComputed?.textClass : 'text-black',
      ]"
    >
      {{ collectionComputed?.collectionTitle }}
    </span>
  </a>
</template>

<script setup>
const props = defineProps({
  collection: String,
  disableShadow: Boolean,
  coloredText: Boolean, // Defaults to black text if false
  titleOverride: String, // Replaces the collection's default label, e.g. licensed designs
});

// The collection lookup stays the source of truth for icon, colors, and link;
// only the visible label is swappable. A title override stands on its own when
// there is no collection to decorate - an Altadena floorplan credits the
// licensor whether or not it belongs to a collection we have an icon for.
const collectionComputed = computed(() => {
  const collectionIcon = getCollectionIcon(props?.collection);

  if (!props?.titleOverride) {
    return collectionIcon;
  }

  return {
    ...collectionIcon,
    collectionTitle: props.titleOverride,
    alt: props.titleOverride,
  };
});
</script>
